import { REQUEST } from '../../../constants/request';

export const initialPermission = {
  userSubscriptions: [],
  hasFollowed: false,
  hasBookmarked: false,
  channelCID: {
    orgId: '',
    streamId: '',
    channelId: '',
  },
  userRoleMapping: {
    userId: '',
    roles: [],
    mapping: [],
  },
  loading: REQUEST.idle,
};

export const initialChannel = {
  channelId: '',
  description: '',
  id: '',
  isFavourite: false,
  metadata: {
    coverPicUrl: '',
    profilePicUrl: '',
    followerCount: 0,
    itemsHash: '',
    platformBoost: 0,
    createdAt: '',
    createdBy: '',
    private: false,
    subscriberCount: 0,
  },
  name: '',
  orgId: '',
  restricted: false,
  streamId: '',
  topics: [],
  locations: [],
  boosts: {},
  visible: false,
  primaryUseCase: null,
  userData: initialPermission,
};

const { userData, channelId, ...originalChannelData } = initialChannel;

export const initialHoveredChannel = {
  channel: {
    ...originalChannelData,
    boosts: {
      ...originalChannelData.boosts,
    },
    metadata: {
      ...originalChannelData.metadata,
    },
  },
  minBoostTag: {
    content: 0,
    promotion: 0,
  },
  subscriptions: [],
  users: [],
  usersOnline: [],
  roles: [],
  moderators: [],
  budget: {
    content: 0,
    promotion: 0,
  },
  maxCostBoosts: {
    content: 0,
    promotion: 0,
  },
  moneyLeftForContent: null,
  allowedBoosts: [],
};

export const initialChannelBookmark = {
  isBookmark: false,
  selectedTags: [],
};
